import './template-collection.scss';
import { atQuery } from '../../scripts/components/mediaQueries';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateCollection = (context) => {
  const templateCollectionSection = context.closest('.shopify-section');
  if (!templateCollectionSection) return;

  const pillsContainer = templateCollectionSection.querySelector('.plp__collection-pills');

  new Swiper(pillsContainer, {
    slidesPerView: "auto",
    spaceBetween: 8,
    on: {
      init: function () {
        updateScrollClasses(this);
      },
      slideChangeTransitionStart: function () {
        pillsContainer.classList.add('scrolling');
      },
      slideChangeTransitionEnd: function () {
        pillsContainer.classList.remove('scrolling');
        updateScrollClasses(this);
      }
    }
  });

  function updateScrollClasses(swiper) {
    const pillsContainer = swiper.el;
    pillsContainer.classList.remove('scrolled-start', 'scrolled-end');
    if (swiper.isBeginning) {
      pillsContainer.classList.add('scrolled-start');
    }
    if (swiper.isEnd) {
      pillsContainer.classList.add('scrolled-end');
    }
  }

  atQuery('max', 'md', () => {
    const filterOpener = templateCollectionSection.querySelector('.facets__drawer-opener');
    const mainWrapper = templateCollectionSection.querySelector('.collection-main-wrapper');

    window.addEventListener('scroll', () => {
      const containerRect = mainWrapper.getBoundingClientRect();
      const filterOpenerRect = filterOpener.getBoundingClientRect();

      if (containerRect.top <= window.innerHeight - filterOpenerRect.height - 20 && containerRect.bottom > window.innerHeight) {
        filterOpener.style.position = 'fixed';
        filterOpener.style.bottom = '20px';
      } else {
        filterOpener.style.position = 'absolute';
        filterOpener.style.bottom = '20px';
      }
    });
  });
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('#CollectionSection'), (el) => {
    window.dAgency.initTemplateCollection(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('#CollectionSection'), (el) => {
      window.dAgency.initTemplateCollection(el);
    });
  });
}
